import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import ContextMenu, { Item } from 'gnos-context-menu'

import { canGenerateDistraints } from '@global/helpers'

import acl from '../../services/acl'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
@acl
export default class ContextBurger extends Component {
    static propTypes = {
        addToFavourites: PropTypes.func.isRequired,
        entity: PropTypes.object,
        favourites: PropTypes.object,
        hasRights: PropTypes.func.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        openLinkagesById: PropTypes.func.isRequired,
        openReportById: PropTypes.func.isRequired,
        setupDistraintsById: PropTypes.func.isRequired,
    }

    onContextMenuAddLinkagesClick = (id) => (e) => {
        e.preventDefault()
        const { openLinkagesById } = this.props

        openLinkagesById(id)
    }

    onContextMenuAddReportClick = (id) => (e) => {
        e.preventDefault()
        const { openReportById } = this.props

        openReportById(_.toString(id))
    }

    onAddToFavourites = (id) => (e) => {
        e.preventDefault()
        const { addToFavourites } = this.props

        addToFavourites(id)
    }

    onContextMenuHandleDistraintsClick = (id) => (e) => {
        e.preventDefault()
        const { setupDistraintsById } = this.props

        setupDistraintsById(_.toString(id))
    }

    getContextMenuContent = () => {
        const { favourites, id, entity } = this.props

        const items = []

        if (this.props.hasRights('report') && !favourites.find(({ entId }) => `${id}` === entId)) {
            items.push(
                <Item
                    key={'favorite'}
                    type={'favorite'}
                    text={<FormattedMessage id={`${LOCALE_PREFIX}.addToFavorite`} />}
                    onItemClick={this.onAddToFavourites(`${id}`)}
                />
            )
        }

        if (this.props.hasRights('report')) {
            items.push(
                <Item
                    key={'report'}
                    type={'report'}
                    text={<FormattedMessage id={`${LOCALE_PREFIX}.generateNewReport`} />}
                    onItemClick={this.onContextMenuAddReportClick(`${id}`)}
                />
            )
        }

        if (this.props.hasRights('linkages')) {
            items.push(
                <Item
                    key={'linkages'}
                    type={'linkages'}
                    text={<FormattedMessage id={`${LOCALE_PREFIX}.generateLinkages`} />}
                    onItemClick={this.onContextMenuAddLinkagesClick(`${id}`)}
                />
            )
        }

        if (this.props.hasRights('distraints') && canGenerateDistraints(entity?.countryIso)) {
            items.push(
                <Item
                    key={'distraints'}
                    type={'distraints'}
                    text={<FormattedMessage id={`${LOCALE_PREFIX}.generateDistraints`} />}
                    onItemClick={this.onContextMenuHandleDistraintsClick(`${id}`)}
                />
            )
        }

        return items
    }

    render() {
        const { id } = this.props

        if (_.isNil(id)) return null

        return (
            <ContextMenu
                id={`entity-context-menu-subject-${id}`}
                content={this.getContextMenuContent()}
                showOnLeftClick
            >
                <div className={'context-menu-burger-button'} />
            </ContextMenu>
        )
    }
}
